import { useEffect, useState } from 'react';
import { jobService } from 'services/job.service';

const usePilotJobs = (
    payload = {
        status: 'InProgress',
        limit: 5
    }
) => {
    const [jobs, setJobs] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const handleApi = async () => {
        try {
            setIsLoading(true);
            const response = await jobService.getPilotJobs(payload);
            setJobs(response.data.data)
        } catch (err) {
            console.log(err)
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (payload) {
            handleApi();
        }
    }, [JSON.stringify(payload)]);

    return { jobsData: jobs, isLoading };
}

export default usePilotJobs;